import { render, staticRenderFns } from "./Numbers.vue?vue&type=template&id=15d9bf50&scoped=true"
import script from "./Numbers.vue?vue&type=script&lang=js"
export * from "./Numbers.vue?vue&type=script&lang=js"
import style0 from "./Numbers.vue?vue&type=style&index=0&id=15d9bf50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d9bf50",
  null
  
)

export default component.exports